import Swal from 'sweetalert2';

import { defaultSwalTimer, defaultSwalWidth, formatHtml } from './helpers';
import { CustomSwalParams, SwalType } from './types';
import { getTheme } from '../../../utils/getTheme';

export class CustomSwal {
  static show(params: CustomSwalParams) {
    const theme = getTheme();

    const colorMap = {
      success: theme.colors.success,
      error: theme.colors.danger,
      warning: theme.colors.warning,
      info: theme.colors.info,
      question: theme.colors.botaoConfirmar,
    };

    const confirmButtonColor =
      params.type == 'success' ? colorMap[params.type] : theme.colors.danger;

    return Swal.fire({
      icon: params.icon ?? params.type ?? 'info',
      title: params.title,
      html: formatHtml(params.html ?? '') ?? params.text,
      timer: params.timer,
      timerProgressBar:
        params.timerProgressBar ?? (params.timer ? true : false),
      showConfirmButton: params.showConfirmButton ?? true,
      confirmButtonText: params.confirmText ?? 'Confirmar',
      confirmButtonColor: params.confirmButtonColor ?? confirmButtonColor,
      cancelButtonText: params.cancelText,
      cancelButtonColor: params.cancelButtonColor ?? theme.colors.warning,
      showCancelButton: !!params.cancelText,
      allowOutsideClick: params.allowOutsideClick ?? true,
      width: params.width ?? defaultSwalWidth(),
    }).then((result) => {
      if (result.isConfirmed && params.onConfirm) {
        Promise.resolve(params.onConfirm());
      } else if (result.isDismissed && params.onCancel) {
        Promise.resolve(params.onCancel());
      }
      return result;
    });
  }

  /**
   * Swal simplificado
   */
  static quick(type: SwalType, message: string) {
    return CustomSwal.show({
      type: type,
      icon: type,
      title:
        type === 'success' ? 'Sucesso' : type === 'error' ? 'Erro' : 'Atenção',
      html: formatHtml(message),
      timer: defaultSwalTimer(),
      showConfirmButton: false,
    });
  }
}
